import { ExpertRespondents } from './ExpertRespondents';

export default ExpertRespondents;